<template>
  <div class="bb-select"
       ref="bbSelect"
       :class="{
       'bb-select_font-little':fontSize === '12',
       'bb-select_high':styles === 'high',
       'bb-select_red':styles === 'red',
       'bb-select_denim':styles === 'denim',
       'bb-select_active':openList}"
       @click.stop="openListSelect($event)"
       @mouseenter="stopHide"
       @mouseleave="hideSelect()"
       v-click-outside="hideSelect">
    <div class="bb-select-container"
         :class="{
          'bb-select-container_hide': hide}"
         ref="bbSelectContainer">
      <div class="bb-select-container__active-item"
           :class="[checkPlaceholder ? 'bb-select-container__active-item_placeholder ' + placeholderClass : titleClass,
           getActiveItem() === '$hide' ? 'bb-select-container__hide-text' : ''
           ]">
        {{getActiveItem()}}
      </div>
      <transition name="fade-submenu">
        <div ref="bbSelectList">
        <vue-perfect-scrollbar class="bb-select-list"
                               :style="{
                                  ...openSelect,
                                  minHeight: minHeight,
                               }"
                               :class="{
          'bb-select-list-table-mode': tableMode,
          'bb-select-list_min-width': minWidth
        }"
                               @mouseenter="stopHide"
                               v-click-outside="hideSelect"
                               @mouseleave="hideSelect()"
                               v-show="openList">
          <div v-for="(item, index) in sortedList"
               :key="item+index"
               class="bb-select-list__item"
               :class="{
               'bb-select-container__hide-text': item.name === '$hide',
               'bb-select-list__item_lowercase': item.name === 'n/a',
               'bb-select-list__item_first': index === 0,
               'bb-select-list__item_last': index === sortedList.length - 1
               }"
               @click.stop="setValue(item)"
          >{{item.name || item.username || item.nickName}}
          </div>
        </vue-perfect-scrollbar>
        </div>
      </transition>
    </div>
    <div class="bb-select-arrow-container" :class="{'bb-select-arrow-container_hide': hide}">
      <i class="icon-cross bb-select-arrow-container__cross" v-if="noSelect" @click.stop="delActiveItem()"/>
      <i class="icon-arrow-select bb-select-arrow-container__arrow"/>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ClickOutside from 'vue-click-outside'
import _ from 'lodash'

export default {
  name: 'CustomSelect',
  props: ['list', 'defaultVal', 'titleClass', 'fixed',
    'placeholderClass', 'hide', 'noSelect', 'sort', 'filterList', 'item',
    'styles', 'name', 'disabled', 'fontSize', 'tableMode', 'minWidth', 'minHeight'],
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      activeIndex: 0,
      openList: false,
      changeItem: {},
      cancelSelect: false,
      sortedList: false,
      newList: {},
      openSelect: {},
      canClose: false
    }
  },
  directives: {
    ClickOutside
  },
  computed: {
    activeItem () {
      if (this.newList && this.newList.length) {
        return this.defaultVal || this.newList[this.activeIndex]
      }
    },
    checkPlaceholder () {
      if (!this.defaultVal) return false
      const setPlaceholder = this.defaultVal === _.get(this.item, 'column.placeholder', '')
      const emptyChange = _.isEmpty(this.changeItem)
      return (!emptyChange || setPlaceholder) && emptyChange
    }
  },
  methods: {
    getActiveItem () {
      const name = _.get(this.changeItem, 'name', '')
      const username = _.get(this.changeItem, 'username', '')
      const nickname = _.get(this.changeItem, 'nickName', '')
      const fullNames = name || username || nickname
      return fullNames || this.activeItem
    },
    delActiveItem () {
      this.openList = false
      this.changeItem = this.sortedList[0]
      this.$emit('setValue', false)
    },
    openListSelect (e) {
      if (this.disabled) {
        return
      }
      this.openList = !this.openList
      if (this.tableMode) {
        this.setAbsoluteForTable()
      }
      if (this.fixed) {
        this.setPositionPopup(e, 'bbSelect')
      }
    },
    hideSelect (force) {
      if (force) {
        this.openList = false
        this.bringBack()
      }
      this.canClose = true
      _.delay(() => {
        if (this.canClose) {
          this.openList = false
          this.bringBack()
        }
      }, 50)
    },
    stopHide () {
      this.$emit('mousenter')
      this.canClose = false
    },
    setPositionPopup (e, ref) {
      const popup = _.get(this.$refs, ref, '')
      const box = popup.getBoundingClientRect()
      this.openSelect = {
        position: 'fixed',
        width: 50 + 'px',
        left: box.left + 14 + 'px',
        top: box.top + 30 + 'px'
      }
    },
    setAbsoluteForTable () {
      const scrollTop = window.pageYOffset
      const scrollLeft = window.pageXOffset
      const select = this.$refs.bbSelectList
      const wrapper = this.$refs.bbSelect
      if (!wrapper || !select) return
      const wrapperPosition = wrapper.getBoundingClientRect()
      select.style.fontSize = getComputedStyle(select).fontSize
      select.style.fontFamily = getComputedStyle(select).fontFamily
      select.style.lineHeight = getComputedStyle(select).lineHeight
      select.style.position = 'absolute'
      select.style.zIndex = 99999
      select.style.left = wrapperPosition.left + scrollLeft + 'px'
      select.style.width = wrapper.offsetWidth + 'px'
      select.style.maxHeight = '200px'
      select.id = 'bbSelectClone'
      document.body.appendChild(select)
      const childes = _.get(select, 'childNodes[0].childNodes', false)
      const heightChild = parseInt(select.style.lineHeight, 10) + 12
      const height = childes ? ((childes.length - 2) * heightChild) + 10 : 200
      const maxHeight = height > 200 ? 199 : height
      if (wrapperPosition.top + height > document.body.clientHeight) {
        select.childNodes[0].classList.add('bb-select-list-table-mode_top')
        select.style.top = wrapperPosition.top + scrollTop - maxHeight + 'px'
      } else {
        select.style.top = wrapperPosition.top + scrollTop + wrapperPosition.height + 'px'
      }
    },
    bringBack () {
      const select = document.getElementById('bbSelectClone')
      const wrapper = this.$refs.bbSelectContainer
      if (select && wrapper) {
        select.childNodes[0].classList.remove('bb-select-list-table-mode_top')
        select.style.cssText = ''
        wrapper.appendChild(select)
      }
    },
    setValue (item) {
      if (!item) return
      if (this.changeItem === item) return
      if (item.name === '$hide') {
        this.delActiveItem()
        return
      }
      if (typeof item === 'string' || typeof item === 'number') {
        return
      }
      this.openList = false
      this.changeItem = item
      this.bringBack()
      this.$emit('setValue', item, this.item)
    },
    getName (valueRole, array) {
      try {
        const name = array.find(item => item.id === valueRole)
        return name
      } catch (e) {
        console.error(e)
      }
    },
    setAllCat  () {
      this.newList = _.map(this.list, item => item)
      if (this.newList.length > 0) {
        this.newList.unshift({
          id: 'all',
          name: 'All'
        })
      }
    }
  },
  beforeDestroy () {
    this.hideSelect(true)
  },
  beforeMount () {
    if (this.filterList) {
      this.setAllCat()
    } else {
      this.newList = this.list
    }
    if (this.name) {
      _.forEach(this.newList, item => {
        item.name = item[this.name]
      })
    }
    if (this.sort) {
      this.sortedList = _.sortBy(this.newList, elem => elem.name)
    } else {
      this.sortedList = this.newList
    }
    if (typeof this.defaultVal === 'string') {
      this.cancelSelect = this.noSelect
    }
    if (this.activeItem) {
      this.setValue(this.activeItem)
    }
    if (typeof this.activeItem === 'string' && this.defaultVal) {
      const item = this.getName(this.activeItem, this.newList)
      if (item) {
        this.setValue(item)
      }
    }
    if (this.noSelect) {
      this.sortedList.unshift({
        id: 'all',
        name: '$hide'
      })
    }
  },
  watch: {
    list: function () {
      if (this.filterList) {
        this.setAllCat()
      } else {
        this.newList = this.list
      }
      this.setValue(this.activeItem)
      if (this.name) {
        _.forEach(this.newList, item => {
          item.name = item[this.name]
        })
      }
      if (this.sort) {
        this.sortedList = _.sortBy(this.newList, elem => elem.name)
      } else {
        this.sortedList = this.newList
      }
    },
    defaultVal: function () {
      this.setValue(this.defaultVal)
    }
  }
}

</script>

<style lang="scss">
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-select {
    @include global-font;
    position: relative;
    font-size: inherit;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    border: none;
    cursor: pointer;
    text-transform: capitalize;

    &_active {
      z-index: 4;
    }

    .ps__thumb-y,
    .ps__thumb-y {
      width: 3px;
    }

    .ps__rail-y.ps--clicking
    .ps__thumb-y,
    .ps__rail-y:focus > .ps__thumb-y,
    .ps__rail-y:hover > .ps__thumb-y {
      width: 3px;
    }

    &-container {
      position: absolute;
      left: 0;
      top: 0;
      padding: 8px 15px;
      width: 100%;
      min-height: 100%;
      overflow: hidden;
      background-color: $color-white;
      border: 1px solid $color-wild-sand;
      border-radius: 5px;

      &__hide-text {
        opacity: 0;
        user-select: none;
      }

      &_hide {
        border: none
      }

      &_active {
        min-height: 100%;
      }

      &__active-item {
        width: 100%;
        height: 100%;
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;

        &_placeholder {
          font-size: 12px;
          color: $color-silver;
        }
      }
    }

    &-list {
      @include global-font;
      position: relative;
      max-height: 200px;
      padding-top: 12px;
      z-index: 2000;

      &_min-width {
        min-width: 150px;
      }

      &-table-mode {
        margin-top: 0;
        padding: 12px 15px 0;
        background-color: $color-white;
        border: 1px solid $color-wild-sand;
        border-top: none;
        border-radius: 0 0 5px 5px;

        &_top {
          border-top: 1px solid $color-wild-sand;
          border-bottom: none;
          border-radius: 5px 5px 0 0;
        }
      }

      &_short {
        max-height: 104px;
      }

      &__item {
        text-transform: capitalize;
        padding-top: 12px;
        cursor: pointer;
        font-weight: normal;
        transition: 0.3s;

        &_lowercase {
          text-transform: lowercase;
        }

        &_first {
          padding-top: 0;
        }

        &_last {
          padding-bottom: 10px;
        }

        &:hover {
          color: $color-accent;
        }
      }
    }

    &-arrow-container {
      position: absolute;
      top: 0;
      right: 10px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 100%;
      cursor: pointer;

      &_hide {
        display: none;
      }

      &__arrow {
        font-size: 5px;
        color: $color-accent;
        transition: all .2s linear;
      }

      &__cross {
        margin-right: 10px;
        font-size: 10px;
        color: rgba($color-black, 0.2);
        cursor: pointer;
      }
    }

    &-list {
      width: 100%;
      background-color: $color-white;
    }

    &_denim {
      .bb-select {
        &-container {
          &__active-item {
            color: $color-accent;

            &_placeholder {
              color: $color-accent;
            }
          }
        }
        &-list {
          &__item {
            color: $color-accent-hover;

            &:hover {
              opacity: 0.8;
            }
          }
        }
      }
    }

    &_red {
      .bb-select {
        &-list {
          .ps__thumb-y,
          .ps__thumb-y {
            background-color: $color-guardsman-red;
          }

          .ps__rail-y.ps--clicking
          .ps__thumb-y,
          .ps__rail-y:focus > .ps__thumb-y,
          .ps__rail-y:hover > .ps__thumb-y {
            background-color: $color-guardsman-red;
          }
        }

        &-arrow-container {
          &__arrow {
            color: $color-guardsman-red;
          }
        }

        &-container {
          &__active-item {
            color: $color-black;

            &_placeholder {
              opacity: 0.7;
            }
          }
        }
        &-list {
          &__item {
            color: $color-black;

            &:hover {
              opacity: 0.6;
            }
          }
        }
      }
    }

    &_high {
      .bb-select {
        &-container {
          &__active-item {
            font-size: 14px;
            line-height: 24px;

            &_placeholder {
              font-size: 14px;
              line-height: 24px;
            }
          }
        }
      }
    }

    &_font-little {
      .bb-select {
        &-container {

          &__active-item {
            font-size: 12px;
            line-height: 24px}
        }

        &-list {
          font-size: 12px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/Inputs/CustomSelect.vue